import styled from 'styled-components';
import { H1, P } from '../elements/Text';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 720px; // we use 820 in intro and outro
  margin: 0 auto;
  margin-top: 72px;
  padding-bottom: 72px;
  height: 100%;
`;

export default function TestWarningMultipleTabs() {
  return (
    <Wrapper>
      <H1 style={{ marginTop: 32 }}>Heads up!</H1>
      <P>It looks like you have another tab open with the same assessment.</P>
      <P>
        <b>Please close this tab and continue where you left off.</b>
      </P>
    </Wrapper>
  );
}
